export default __webpack_public_path__ + "static/media/LOOP MUSIC INTRO.a01ad0aa.mp3";